<div class="connectivity-main-page">
  <div class="connectivity-main-page__container">
    <div class="connectivity-main-page__actions">
      <button class="vox-btn vox-btn-secondary connectivity-main-page__add-equipment" (click)="onAddCatalogEntry()" translate>connectivity.add-button</button>
    </div>
    <div class="connectivity-main-page__filters">
      <gdp-connectivity-filters (filtersChanged)="onFiltersChanged($event)"></gdp-connectivity-filters>
    </div>
    <div class="connectivity-main-page__table">
      <gdp-connectivity-table 
        [loadingTable]="loadingCatalogList"
        [loadingLines]="tableLoadingLines"
        [catalogEntryList]="paginatedCatalogEntryList?.content" 
        (editEntry)="onEditCatalogEntry($event)"
        (editEntryDocuments)="onEditEntryDocuments($event)"
        (deleteEntry)="onDeleteCatalogEntry($event)"
      ></gdp-connectivity-table>
    </div>
    <div class="connectivity-table-page__pagination">
      <gdp-table-pagination (onSelectPageSize)="selectPageSize($event)" (onChangeCurrentPage)="changeCurrentPage($event)" [totalPages]="pagination.totalPages" [pagination]="pagination" [selectedPageSize]="pageSize"></gdp-table-pagination>
    </div>
  </div>
</div>